<template>
    <div class="atom-text">

        <TransitionFade>
            <div 
                v-if="displayText"  
                class="text" 
                v-html="displayText">
            </div>
        </TransitionFade>

    </div>
</template>

<script>
import { TransitionFade } from '@generio-ai/library-legacy/components/transitions'

export default {
    name: 'AtomText',
    components: {
        TransitionFade
    },
    props: {
        text: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            displayText: null,
        }
    },
    watch: {
        text(newValue, oldValue) {
            if (newValue === oldValue) return
            this.displayText = newValue
        },
    },
    mounted() {
        this.displayText = this.text
    }
}
</script>

<style scoped>
.atom-text {
    box-sizing: border-box;
    min-height: 1.1rem;
    max-height: 2rem;
    overflow: hidden;
    user-select: none;
}

.atom-text .text {
    font-size: 1.5rem;
    color: rgb(var(--v-theme-primary));
}
</style>